import React from "react";
import styles from "./Header.module.scss";
import {withRouter} from 'react-router-dom';

const Header = props => {
  const toHome = () => {
    props.history.push('/')
  }
  return <header>
    <div className={`heroBanner heroBanner2`}>
      <div className={`container`}>
        <h1>Australian Death Notification Service</h1>
      </div>
    </div>
  
  </header>
};

export default withRouter(props => <Header {...props}/>);
